// extracted by mini-css-extract-plugin
export var actualiteContentFooter = "detailsActu-module--actualite-content-footer--4f2d2";
export var actualiteContentFooterBack = "detailsActu-module--actualite-content-footer-back--2bb67";
export var actualiteImg = "detailsActu-module--actualite-img--b0f73";
export var actualiteTitle = "detailsActu-module--actualite-title--91502";
export var editButton = "detailsActu-module--edit-button--a6daa";
export var gridAriane = "detailsActu-module--grid-ariane--92110";
export var gridContent = "detailsActu-module--grid-content--83021";
export var gridDate = "detailsActu-module--grid-date--83cf6";
export var gridResume = "detailsActu-module--grid-resume--8efb7";
export var gridTags = "detailsActu-module--grid-tags--b03bc";
export var gridTitle = "detailsActu-module--grid-title--5b40c";
export var pageActu = "detailsActu-module--page-actu--924c8";
export var pageActuAdditionalInfos = "detailsActu-module--page-actu-additional-infos--4ee78";